import React, {PropsWithChildren} from "react";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {AppBar, Button, Toolbar} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        appBar: {
            top: 'auto',
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backgroundColor: "#FFF",
            "& .MuiToolbar-root": {
                justifyContent: "space-evenly",
                minHeight: 0,
                padding: 5
            },
            "& .MuiButtonBase-root": {
                marginRight: 10,
                marginLeft:10,
                width: 150
            }
        },
    }),
);


type CloseBottomBarProps = {
    path?: string,
    executeClose?: () => void
};

const CloseBottomBar: React.FC<PropsWithChildren<CloseBottomBarProps>> = ({path, executeClose, children}) => {

    const {t} = useTranslation();
    const classes = useStyles();

    const render = (<AppBar position="fixed" className={classes.appBar} id={"close-button-bar"}>
        <Toolbar>
            <Button href={path} variant="contained" size="small"
                    onClick={() => executeClose && executeClose()}
                    fullWidth={false}
            >{t("core.close")}</Button>
            {children}
        </Toolbar>
    </AppBar>);

    return render;
};

export default CloseBottomBar;
